import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { toString1pkumu07cwy4m as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { JsonNumber2j5ykr5cbjkre as JsonNumber } from './JsonNumber.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function writeAny(_this__u8e3s4, value) {
  if (value == null)
    _this__u8e3s4.f40();
  else {
    if (!(value == null) ? isInterface(value, KtMap()) : false) {
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.a41();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = value.q3().u1();
      while (_iterator__ex2g4s.v1()) {
        var element = _iterator__ex2g4s.w1();
        // Inline function 'kotlin.collections.component1' call
        var key = element.r3();
        // Inline function 'kotlin.collections.component2' call
        var value_0 = element.s3();
        _this__u8e3s4.c48(toString(key));
        writeAny(_this__u8e3s4, value_0);
      }
      _this__u8e3s4.b41();
    } else {
      if (!(value == null) ? isInterface(value, KtList()) : false) {
        // Inline function 'com.apollographql.apollo.api.json.writeArray' call
        _this__u8e3s4.f41();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = value.u1();
        while (_iterator__ex2g4s_0.v1()) {
          var element_0 = _iterator__ex2g4s_0.w1();
          writeAny(_this__u8e3s4, element_0);
        }
        _this__u8e3s4.g41();
      } else {
        if (!(value == null) ? typeof value === 'boolean' : false)
          _this__u8e3s4.w41(value);
        else {
          if (!(value == null) ? typeof value === 'number' : false)
            _this__u8e3s4.o41(value);
          else {
            if (!(value == null) ? typeof value === 'bigint' : false)
              _this__u8e3s4.u41(value);
            else {
              if (!(value == null) ? typeof value === 'number' : false)
                _this__u8e3s4.r41(value);
              else {
                if (value instanceof JsonNumber())
                  _this__u8e3s4.s4a(value);
                else {
                  if (!(value == null) ? typeof value === 'string' : false)
                    _this__u8e3s4.m41(value);
                  else {
                    // Inline function 'kotlin.error' call
                    var message = 'Cannot write ' + toString(value) + " of class '" + toString_0(getKClassFromExpression(value)) + "' to Json";
                    throw IllegalStateException().o(toString_0(message));
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
//region block: exports
export {
  writeAny as writeAny16i13331zbqlc,
};
//endregion

//# sourceMappingURL=JsonWriters.mjs.map
